import React from 'react';

export default function CloseIcon(props) {
  return (
    <svg width={12} height={12} {...props}>
      <path d="M12 .9l-.9-.9L6 5.1.9 0 0 .9 5.1 6 0 11.1l.9.9L6 6.9l5.1 5.1.9-.9L6.9 6z" />
    </svg>
  );
}
